import { ProductOptionType } from "../interfaces/product-option.interface";
import { BaseModel } from "./base-class.model";

export class Product extends BaseModel<Product> {
  produtoId?: number;
  avaliacaoRating?: number;
  categoriaId?: number;
  descricao?: string;
  imagem?: string;
  isPartMeioMeio?: boolean;
  nome?: string;
  numberMeiomeio?: number;
  optionsCount?: number;
  produtoGuid?: string;
  referenciaId?: number;
  sequencia?: number;
  situacao?: number;
  tamanhoId?: number;
  tokenRestaurante?: string;
  valorPromocao?: number;
  valorRegular?: number;
  valorVenda?: number;
  produtopulse?: 0 | 1;

  produtoOpcaoTipos?: ProductOptionType[];
}
